import React, { useEffect, useState } from 'react';
import { Flex, Text } from "@chakra-ui/layout";
import { Badge, Grid, Link } from "@chakra-ui/react";
import socket from "../../../utilities/socket";
import { useSelector } from "react-redux";
import { StateType } from "../../../store/store";
import { NavLink } from "react-router-dom";
import { Iconly } from 'react-iconly';

type room = {
  userName: string, role: string, room: string
}

function StudentClass() {
  const [liveClasses, setLiveClasses] = useState<{ [key: string]: { time: string, className: string, users: room[] } }>({})
  const { registeredCourses } = useSelector((state: StateType) => state.rootReducer.studentReducer);
  console.log(registeredCourses)
  socket.connect();
  socket.on("live-class", (classes) => {
    //console.log(classes);
    setLiveClasses(classes);
  })

  useEffect(() => {
  }, [liveClasses])

  return (
    <Flex flexDirection={"column"} boxShadow="2xl" m={7} p={5} borderRadius={"20px"}>
      <Flex justifyContent={"space-between"}>
        <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"2xl"}>Classes</Text>
        <Link as={NavLink} to={"/student/registered-courses"} title={"see registered courses"} bgColor={"rgba(17, 24, 39, 0.5)"}
          p={1.5} borderRadius={"50%"} mr={"12px"}>
          <Iconly label={"setting"} name="Setting" set="bold" primaryColor="white" size="medium" />
        </Link>
      </Flex>
      <Grid gridTemplateColumns={"repeat(auto-fit, minmax(250px, 280px))"} justifyContent={"center"}>
        {Object.entries(liveClasses).length > 0 ? (
          Object.values(liveClasses).map((classes, index) => (
            <Flex key={index} bgColor={"brand.white"} flexDirection={"column"} m={4} borderRadius={"20px"} p={6}>
              <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"lg"}>
                {classes.className}
              </Text>
              {classes.users.filter((user) => user.role === "tutor").length > 0 && (
                <Text textTransform={"capitalize"} fontWeight={"extrabold"} color="grey" fontSize={"xs"}>
                  {classes.users.filter((user) => user.role === "tutor")[0].userName}
                </Text>
              )}
              <Flex justifyContent="space-between">
                <Text fontWeight={"light"} fontSize={"xs"}>
                  {classes.users.length} {" "} Participant(s)
                </Text>
                <Badge variant="solid" bgColor="black" fontSize="xs" borderRadius="7px">
                  {classes.time}
                </Badge>
              </Flex>
              <Link as={NavLink} to={`/class/${classes.className}`} textTransform={"capitalize"}>
                join
              </Link>
            </Flex>
          ))
        ) : (
          <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"lg"}>No Live Classes</Text>
        )}
      </Grid>
    </Flex>
  );
}

export default StudentClass;